export type CellValidClassName =
  | "crud_disabled"
  | "crud_invalid"
  | "crud_transitive"
  | "crud_warning";

export class CellValidState {
  public valid: boolean;
  /**
   * css
   */
  public className: CellValidClassName;
  public message: string;

  constructor(valid: boolean, className: CellValidClassName, message: string) {
    this.valid = valid;
    this.className = className;
    this.message = message;
  }
}
